// Mostra a barra de rolagem da pagina enquanto a tela estiver aberta. O app esconde todas as
// barras por padrao; o estilo que as reexibe fica em public/styles/scrollbar-visivel.css.
const CLASSE = "scrollbar-visivel";

export default {
  mounted() {
    document.documentElement.classList.add(CLASSE);
  },
  beforeDestroy() {
    document.documentElement.classList.remove(CLASSE);
  }
};
